<template>

  <div>
    <!--名片列表-->
    <CardList v-if="activeName == 'cardlist'"></CardList>
    <!-- 续费订单 -->
    <CardGradeOrder v-if="activeName == 'cardgrade'"></CardGradeOrder>
    <!--人脉圈-->
    <Category v-if="activeName == 'category'"></Category>
    <!--标签-->
    <Label v-if="activeName == 'label'"></Label>
    <!--权限-->
    <Auth v-if="activeName == 'auth'"></Auth>
    <!--分销设置-->
    <Setting v-if="activeName == 'setting'"></Setting>
  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import PlusApi from '@/api/plus.js';
import CardList from './cardlist/index';
import Category from './category/index';
import Setting from './setting/getSetting';
import Label from './label/index';
import Auth from './cardauth/index';
import CardGradeOrder from './cardgrade/cardgrade';

export default {
  components: {
    CardList,
    Category,
    Label,
    Setting,
    Auth,
    CardGradeOrder
  },
  data() {
    return {
      formInline: {
        nick_name: ''
      },
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'cardlist',
      /*切换数组*/
      sourceList: [
        {
          key: 'cardlist',
          value: '名片列表',
          path:'/plus/card/cardlist/index'
        },
        {
          key: 'category',
          value: '名片分类',
          path:'/plus/card/category/index'
        },
        {
          key: 'cardgrade',
          value: '续费订单',
          path:'/plus/card/cardgrade/cardgrade'
        },
        {
          key: 'label',
          value: '标签列表',
          path:'/plus/card/label/index'
        },
        {
          key: 'auth',
          value: '权限设置',
          path:'/plus/card/cardauth/index'
        },
       
        {
          key: 'setting',
          value: '名片设置',
          path:'/plus/card/setting/getSetting'
        },
       
      ],
      /*权限筛选后的数据*/
      tabList:[],
      /*判断third是否有参数*/
      is_third_param: false
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {

    this.init();

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'card',list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'card'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/card/index.vue